import React from 'react';
import Icon from '../../../components/AppIcon';

const TableOfContents = ({ sections, activeSection, onSectionClick }) => {
  return (
    <div className="bg-white rounded-xl border border-border p-6 sticky top-24">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="List" size={20} className="text-primary" />
        <h3 className="font-jakarta font-semibold text-lg text-text-primary">
          Table of Contents
        </h3>
      </div>
      <nav className="space-y-2">
        {sections?.map((section) => (
          <button
            key={section?.id}
            onClick={() => onSectionClick(section?.id)}
            className={`w-full text-left px-3 py-2 rounded-lg text-sm font-inter transition-all duration-200 hover:bg-surface ${
              activeSection === section?.id
                ? 'bg-primary/10 text-primary border-l-2 border-primary' :'text-text-secondary hover:text-text-primary'
            }`}
          >
            {section?.title}
          </button>
        ))}
      </nav>
      <div className="mt-6 pt-4 border-t border-border">
        <p className="text-xs text-text-secondary font-inter">
          Last updated: November 2, 2025
        </p>
        <p className="text-xs text-text-secondary font-inter mt-1">
          Version 2.1
        </p>
      </div>
    </div>
  );
};

export default TableOfContents;